import React, { useState } from 'react';

const CustomerRepairModal = ({ isOpen, onClose, customer, asRecords = [] }) => {
  const [keyword, setKeyword] = useState('');

  if (!isOpen || !customer) return null;

  // 🚀 [실시간 연동] 부품판매가 아니면서 현재 고객명과 동일한 정비 기록만 필터링
  const repairHistories = asRecords.filter(r => r.customerName === customer.name && r.serviceCategory !== '부품판매');
  
  const filteredRecords = repairHistories.filter(r => 
    String(r.action || r.symptom || r.inspection || '').toLowerCase().includes(keyword.toLowerCase()) ||
    String(r.mechanic || '').toLowerCase().includes(keyword.toLowerCase())
  );

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(15, 23, 42, 0.6)' }} onClick={onClose} />
      
      <div style={{ position: 'relative', background: 'white', width: '600px', maxHeight: '85vh', borderRadius: '16px', display: 'flex', flexDirection: 'column', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' }}>
        
        {/* 헤더 */}
        <div style={{ padding: '20px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#eff6ff', borderRadius: '16px 16px 0 0' }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '800', color: '#1e293b' }}>
              🔧 {customer.name} 고객 정비 현황 조회
            </h2>
            <div style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>
              {customer.carNumber || '차량번호 없음'} | {customer.phone}
            </div>
          </div>
          <button onClick={onClose} style={{ padding: '8px 16px', background: '#dbeaf8', color: '#1e40af', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>닫기 ✖</button>
        </div>

        {/* 상단 통합 검색 바 */}
        <div style={{ padding: '15px 20px', background: 'white', borderBottom: '1px solid #e2e8f0' }}>
          <input 
            type="text" 
            placeholder="정비 내용 또는 담당 정비사 검색..."
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            style={{ width: '100%', boxSizing: 'border-box', padding: '10px 15px', border: '1px solid #bfdbfe', borderRadius: '8px', outline: 'none', fontSize: '13px' }}
          />
        </div>

        {/* 목록 리스트 */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px', background: '#f1f5f9', display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {filteredRecords.length > 0 ? (
            filteredRecords.map((r, idx) => (
              <div key={r.id || idx} style={{ background: 'white', padding: '15px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '12px' }}>
                  <span style={{ fontWeight: 'bold', color: '#2563eb', background: '#dbeaf8', padding: '2px 6px', borderRadius: '4px' }}>{r.status || '완료'}</span>
                  <span style={{ color: '#94a3b8' }}>{r.settleDate || r.asDate}</span>
                </div>
                <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#1e293b', marginBottom: '6px' }}>
                  {r.action || r.symptom || '정비 내용 없음'}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#64748b', marginTop: '10px', borderTop: '1px dashed #f1f5f9', paddingTop: '8px' }}>
                  <span>담당자: {r.mechanic || '-'}</span>
                  <span style={{ fontWeight: 'bold', color: '#0f172a' }}>₩ {Number(r.totalCost || 0).toLocaleString()}</span>
                </div>
              </div>
            ))
          ) : (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#94a3b8', fontSize: '13px' }}>
              조건에 맞는 정비 이력이 존재하지 않습니다.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerRepairModal;